import { render, staticRenderFns } from "./ImageSwiperSelector.vue?vue&type=template&id=0b330ab3&scoped=true&"
import script from "./ImageSwiperSelector.vue?vue&type=script&lang=js&"
export * from "./ImageSwiperSelector.vue?vue&type=script&lang=js&"
import style0 from "./ImageSwiperSelector.vue?vue&type=style&index=0&id=0b330ab3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b330ab3",
  null
  
)

export default component.exports